import configs from '@acre/config'

import { getCaseSearchResults } from '../api/case_search'
import { getSearchResults } from '../api/search'
import type { Resolvers } from '../generated/server/resolvers'

const { SEARCH_API_URL } = configs

const SearchResolver: Resolvers = {
  Query: {
    search: async (_parent, { searchFragment, owning_org_id, show_client, bookmark }) => {
      const params = new URLSearchParams({
        ...(show_client && { show: 'CLIENT' }),
        ...(owning_org_id && { owning_org_ids: owning_org_id }),
        ...(bookmark && { bookmark: bookmark.toString() }),
      }).toString()

      const url = `${SEARCH_API_URL}search?q=${searchFragment}${params ? `&${params}` : ''}`
      const result = await getSearchResults(url, {})
      return result || null
    },
    caseSearch: async (_parent, { searchFragment, bookmark }) => {
      const params = new URLSearchParams({
        ...(bookmark && { bookmark: bookmark.toString() }),
      }).toString()

      const url = `${SEARCH_API_URL}case_search?q=${searchFragment}${params ? `&${params}` : ''}`
      const result = await getCaseSearchResults(url, {})
      return result || null
    },
  },
}

export default SearchResolver
